const page_name = 1
export default {
  // page_name##页面名称(1:商品详情页)&&
  // info_content{
  // info_content_id##商品头部信息内容id(1:价格显示;2:文字链;3:同系列推荐;4:到手价;5:积分抵现;6:下拉折叠按钮;9:机型对比)&&
  // info_content_type##内容类型(1-1:含有免息标签;1-2:有活动优惠;1-3:有分期优惠;1-4:包含商城发券/满减活动优惠时;1-5:包含会员券/满减活动优惠;4-1:到手预估;4-2:黄金专享;4-3:白银专享)&&}
  // sku_id##商品skuid&&
  // recommend_spu##同系列推荐商品spu
  baseInfo: obj => {
    return [
      {
        act: 'show',
        params: { cfrom: '174|001|02|077', event_id: '174|001|02|077', page_name, ...obj }
      }
    ]
  },
  baseInfoClick: params => {
    return [
      {
        act: 'click',
        params: {
          cfrom: '174|001|01|077',
          event_id: '174|001|01|077',
          page_name,
          ...params
        }
      }
    ]
  }
}
